import BaseService from '../../BaseService.js';

export default class BranchenService extends BaseService {

    constructor() {
        super('branchen')
    }
}